module.exports = __webpack_public_path__ + "img/HGB-Stier.5b32e19a.jpg";